import { render, staticRenderFns } from "./AddFinalProduct.vue?vue&type=template&id=bdd00e5a"
import script from "./AddFinalProduct.vue?vue&type=script&lang=js"
export * from "./AddFinalProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports